<script>
  import { getContext } from 'svelte';

  const { xScale, data } = getContext('LayerCake');
</script>

{#each $data as line, i}
{#if i === $data.length - 1}
<line stroke="#000" x1={$xScale(line.v) - 2.5} x2={$xScale(line.v) - 2.5} y1=5 y2=15></line>
{/if}
<circle fill={line.fill} r=5 cy={i === $data.length - 1 ? 5 : 15} cx={$xScale(line.v) - 2.5} height=10></circle>
{/each}